// eslint-disable-next-line max-len
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {
  AbstractControl,
  FormGroupDirective,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import * as cloneDeep from 'lodash/cloneDeep';
import * as moment from 'moment';
import { ReplaySubject, Subject, forkJoin } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import {
  AlertConditionModel,
  AlertNotificationDetailModel,
  Attachment,
  SiteModel,
  SiteStepperModel
} from 'src/app/models/index';
import { DataService } from 'src/app/services/data.service';
import {
  CommonService,
  SiteService,
  SiteStepperService
} from 'src/app/services/index';
import {
  AlertService,
  Constants,
  Moment$,
  SiteStepperEnum
} from 'src/app/shared';
@Component({
  selector: 'app-alerts-configuration',
  templateUrl: './alerts-configuration.component.html',
  styleUrls: ['./alerts-configuration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertsConfigurationComponent
  implements OnInit, AfterViewChecked, AfterViewInit
{
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChildren('loadSelect') loadSelect: QueryList<MatSelect>;
  @ViewChild('formDirective') formDirective: FormGroupDirective;
  requiredValidators = [Validators.required];
  valueValidators = [Validators.required, Validators.pattern('[0-9]*')];
  siteId = '';
  siteModel: SiteModel;
  stepTitle = 'Alerts Configuration';
  alertsDataSource: MatTableDataSource<any>;
  origAlerts = [];
  // tempAlerts: any;
  displayedColumns = [
    'name',
    'loadName',
    'parameter',
    'selectedCondition',
    'watchWindowFromTime',
    'watchWindowToTime',
    'type',
    'frequency',
    'mailTo',
    'select'
  ];
  checkedAll = false;
  // Add/Edit Alerts
  noData = 'No data received';
  loadsBuilt = false;
  formMasterGroup: UntypedFormGroup;
  formMisGroup: UntypedFormGroup;
  selectedAlertRId = undefined;
  isAddingOrUpdatingAlert = false;
  alert: any;
  operators = Constants.OPERATORS;
  logicOperators = [
    { value: 'AND', text: 'AND' },
    { value: 'OR', text: 'OR' },
    { value: 'NOT', text: 'NOT' },
    { value: 'NOR', text: 'NOR' },
    { value: 'XOR', text: 'XOR' },
    { value: 'XNOR', text: 'XNOR' }
  ];
  days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  customDays = this.days.map((x) => ({ text: x, value: x, selected: false }));
  alertForTypes = [
    Constants.ALERT_FOR_TYPE.SOLAR,
    Constants.ALERT_FOR_TYPE.OTHER
  ];
  frequencies = Constants.FREQUENCIES;
  // TODO:MIS REPORT
  criticalityLevel = ['Low', 'Medium', 'High'];
  targetDuration = ['Monthly', 'Yearly'];
  serviceName = [
    'Real Time Power',
    'Shiftwaise Energy',
    'Current',
    'Process Water'
  ];
  alertContentTypes = [
    { value: 'default', text: 'Default Text' },
    { value: 'custom', text: 'Custom Text' }
  ];
  // eslint-disable-next-line max-len
  alertTypes = [
    { value: 'SMS', text: 'SMS' },
    { value: 'Email', text: 'Email' },
    { value: 'PortalNotificationBar', text: 'Portal Notification Bar' }
  ];
  alertLevels = [
    { value: 'level1', text: 'Level-1' },
    { value: 'level2', text: 'Level-2' },
    { value: 'level3', text: 'Level-3' },
    { value: 'level4', text: 'Level-4' }
  ];
  columnsOnPortal = [
    'Interrupts',
    'Availability',
    'Consumption',
    'Interruption Time'
  ];
  currencies = ['JPY', 'INR', 'USD'];
  loads = [];
  paramArr = [];
  shifts = [];
  keepConditionSelection = [true];
  showDigitalValueMap = [false];
  maxAlertConditions = 3;
  alertTypeAll = false;
  form: any;
  alertContent = '';
  alertLevelAll = false;
  emailList = [];
  AlertToMISReport = 'no';
  logoAttachment: Attachment = new Attachment();
  activeAlertsList = [];
  misServiceList = [];
  /** list of banks filtered by search keyword */
  public filteredLoads: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();
  protected _onLoadDestroy = new Subject<void>();
  isDuplicatedAlert = false;
  constructor(
    private siteStepperService: SiteStepperService,
    private siteService: SiteService,
    private dataService: DataService,
    private commonService: CommonService,
    private alertService: AlertService,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    this.formMasterGroup = this.fb.group({
      selectedAlertRIdCtr: [''],
      alertNameCtr: [
        '',
        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern('[a-zA-Z0-9_& ./:,-]*'),
          this.startWhitespace
        ]
      ],
      alertConditionsItems: this.fb.array([]),
      // confirmedPresenceSampleCountCtr: ['', [Validators.required, Validators.min(1), Validators.max(90)]],
      confirmedPresenceSampleCountCtr: ['', [Validators.required]],
      confirmedAbsenceSampleCountCtr: ['', [Validators.pattern('[0-9]*')]],
      alertForTypeCtr: ['', [Validators.required]],
      alertNotificationFrequencyCtr_0: [''],
      alertNotificationFrequencyCtr_1: [''],
      alertNotificationFrequencyCtr_2: [''],
      criticalityLevelCtr: ['', [Validators.required]],
      alertContentCtr: ['', [this.startWhitespace]],
      emailRecepientToListCtr: ['', []],
      emailRecepientCcListCtr: [''],
      emailRecepientBccListCtr: [''],
      sendWindowFromTimeCtr: [
        '',
        [Validators.required, this.timeComp('sendWindowToTimeCtr')]
      ],
      sendWindowToTimeCtr: [
        '',
        [Validators.required, this.timeComp('sendWindowFromTimeCtr')]
      ],
      sendWindowOnDays: [''],
      sendWindowOnDayCtr_0: [''],
      sendWindowOnDayCtr_1: [''],
      sendWindowOnDayCtr_2: [''],
      sendWindowOnDayCtr_3: [''],
      sendWindowOnDayCtr_4: [''],
      sendWindowOnDayCtr_5: [''],
      sendWindowOnDayCtr_6: ['']
    });
    this.formMisGroup = this.fb.group({
      newServiceCtr: [''],
      enabledAlertCtr: [''],
      misServiceCtr: [''],
      criticalityMisLevelCtr: [''],
      costCtr: [''],
      currencyCtr: [''],
      targetDurationCtr: [''],
      columnsOnPortalCtr_0: [''],
      columnsOnPortalCtr_1: [''],
      columnsOnPortalCtr_2: [''],
      columnsOnPortalCtr_3: ['']
    });
  }
  public startWhitespace(control: UntypedFormControl) {
    if (
      (control.value as string) &&
      (control.value as string).indexOf(' ') == 0
    ) {
      return { whitespace: true };
    }
    return null;
  }
  timeCompare(controlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      if (control.value) {
        const time1 = control.value;
        const time2 = control.parent.controls[controlName].value;
        const errors = control.parent.controls[controlName].errors;
        if (errors && 'time' in errors) {
          control.parent.controls[controlName].setErrors(null);
        }
        if (controlName === 'watchWindowToTimeCtr' && time1 > time2) {
          return { time: { invalid: true } };
        }
        if (controlName === 'watchWindowFromTimeCtr' && time1 < time2) {
          return { time: { invalid: true } };
        }
      }
    };
  }
  timeComp(controlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      if (control.value) {
        const time1 = control.value;
        const time2 = control.parent.controls[controlName].value;
        const errors = control.parent.controls[controlName].errors;
        if (errors && 'stime' in errors) {
          control.parent.controls[controlName].setErrors(null);
        }
        if (controlName === 'sendWindowToTimeCtr' && time1 > time2) {
          return { stime: { invalid: true } };
        }
        if (controlName === 'sendWindowFromTimeCtr' && time1 < time2) {
          return { stime: { invalid: true } };
        }
      }
    };
  }
  ngOnInit() {
    this.initAlertObject();
    this.siteModel = new SiteModel();
    this.siteStepperService.getStepperSubject().subscribe((data) => {
      if (
        data.selectedIndex === SiteStepperEnum.AlertsConfiguration &&
        !this.commonService.isNullOrUndefined(data.siteModel)
      ) {
        this.formMasterGroup.reset();
        this.siteModel = data.siteModel;
        this.siteId = this.siteModel.siteId;
        this.fetchSavedAlerts();
        this.siteService.getShiftsBySiteId(this.siteId).subscribe((shifts) => {
          this.shifts = shifts;
          this.shifts.push({ shiftId: '-1', shiftName: 'All Shifts' });
        });
        this.siteService
          .getUserEmailsBySiteId(this.siteId)
          .subscribe((emailList) => {
            this.emailList = emailList;
          });
        this.getExistingAlertList();
        this.getExistingMISserviceList();
      }
    });
  }
  private fetchSavedAlerts = () => {
    this.siteService.getAlertsBySiteId(this.siteId).subscribe((alerts) => {
      this.alertsDataSource = new MatTableDataSource<any>(alerts);
      this.origAlerts = cloneDeep(alerts);
      this.alertsDataSource.paginator = this.paginator;
      this.onAlertCheckedChange();
    });
  };
  private getExistingAlertList = () => {
    this.siteService
      .getAlertsListBySiteId(this.siteId)
      .subscribe((activeAlertsList) => {
        this.activeAlertsList = activeAlertsList;
      });
  };
  private getExistingMISserviceList = () => {
    this.siteService.getMisServices(this.siteId).subscribe((misServiceList) => {
      this.misServiceList = misServiceList;
    });
  };
  private initAlertObject = () => {
    this.form = {};
    this.form.alertContentType = 'default';
    this.alert = {};
    this.clearChildAlert();
  };
  private clearChildAlert = () => {
    this.alert.activate = 'false';
    this.alert.alertConditions = [];
    const alertConditionsItems = this.formMasterGroup.get(
      'alertConditionsItems'
    ) as UntypedFormArray;
    alertConditionsItems.controls = [];
    alertConditionsItems.updateValueAndValidity();
    const alertNotificationDetails: AlertNotificationDetailModel[] = [];
    for (let i = 0; i < this.alertTypes.length; i++) {
      const type = {
        value: this.alertTypes[i].value,
        text: this.alertTypes[i].text,
        selected: false
      };
      alertNotificationDetails.push(new AlertNotificationDetailModel(type));
      // this.changeChkBoxAlertType(i);
    }
    this.alert.alertNotificationDetails = alertNotificationDetails;
    for (let i = 0; i < this.alert.alertNotificationDetails.length; i++) {
      this.changeChkBoxAlertType(i);
    }
    this.alert.alertLevels = this.alertLevels.map((x) => ({
      text: x.text,
      value: x.value,
      selected: false
    }));
    for (let i = 0; i < this.customDays.length; i++) {
      this.customDays[i].selected = false;
    }
    this.alert.sendWindowOnDays = cloneDeep(this.customDays);
    const temp = [];
    for (let i = 0; i < this.columnsOnPortal.length; i++) {
      const type = {
        value: this.columnsOnPortal[i],
        text: this.columnsOnPortal[i],
        selected: false,
        textValue: null
      };
      temp.push(type);
      // this.onColumnsOnPortalChange(i);
    }
    this.alert.columnsOnPortal = temp;
    for (let i = 0; i < this.alert.columnsOnPortal.length; i++) {
      this.setChkBoxColumnsOnPortalValidator(i);
    }
    // eslint-disable-next-line max-len
    // this.alert.columnsOnPortal = cloneDeep(this.columnsOnPortal.map(x => ({'text' : x, 'value': x, 'selected': false, 'textValue': null})));
  };

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  public checkAll = () => {
    for (let i = 0; i < this.alertsDataSource.data.length; i++) {
      this.alertsDataSource.data[i].activate = this.checkedAll;
    }
  };
  public onAlertCheckedChange = () => {
    this.checkedAll = this.alertsDataSource.data.every(function (item: any) {
      return item.activate === true;
    });
  };
  public saveActivationsChanges = (event: any) => {
    event.preventDefault();
    const activateRids = this.alertsDataSource.data
      .filter((x) => x.activate === true)
      .map((y) => {
        return y.rId;
      });
    const deactivateRids = this.alertsDataSource.data
      .filter((x) => x.activate === false)
      .map((y) => {
        return y.rId;
      });
    const successMess = 'Save Alerts Activations Changes successfully!';
    const failMess = 'Fail on save alerts activations';
    const isForkJoin = activateRids.length > 0 && deactivateRids.length > 0;
    if (isForkJoin) {
      forkJoin(
        this.siteService.activateAlerts(activateRids),
        this.siteService.deactivateAlerts(deactivateRids)
      ).subscribe(([activateAlertsRes, deactivateAlertsRes]) => {
        if (activateAlertsRes === true && deactivateAlertsRes === true) {
          this.origAlerts = cloneDeep(this.alertsDataSource.data);
          this.alertService.message = successMess;
          this.alertService.showSuccess(successMess);
        } else {
          this.alertService.message = failMess;
          this.alertService.showError(failMess);
        }
      });
    } else {
      if (activateRids.length > 0) {
        this.siteService.activateAlerts(activateRids).subscribe((data) => {
          if (data === true) {
            this.origAlerts = cloneDeep(this.alertsDataSource.data);
            this.alertService.message = successMess;
            this.alertService.showSuccess(successMess);
          } else {
            this.alertService.message = failMess;
            this.alertService.showError(failMess);
          }
        });
      }
      if (deactivateRids.length > 0) {
        this.siteService.deactivateAlerts(deactivateRids).subscribe((data) => {
          if (data === true) {
            this.origAlerts = cloneDeep(this.alertsDataSource.data);
            this.alertService.message = successMess;
            this.alertService.showSuccess(successMess);
          } else {
            this.alertService.message = failMess;
            this.alertService.showError(failMess);
          }
        });
      }
    }
  };
  public cancel = (event: any) => {
    event.preventDefault();
    this.alertsDataSource.data = cloneDeep(this.origAlerts);
    this.onAlertCheckedChange();
  };
  public export = (event: any) => {
    event.preventDefault();
    const url = this.siteService.exportAlerts(this.siteId);
    // window.open(url, '_self');
    this.dataService.getPDF(url, true).subscribe((response) => {
      if (response.byteLength > 0) {
        const file = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const fileURL = URL.createObjectURL(file);
        // window.open(fileURL, '_blank');
        window.open(fileURL, 'window2');
      } else {
        this.alertService.message = 'No data response !';
        this.alertService.showError(this.alertService.message);
      }
    });
  };
  // Event on Add/Edit Alert
  public onOpenEditAlert = () => {
    // Call api only Open edit Panel in the first time
    const hydLoad = {
      siteID: this.siteId,
      subType: 'Hydraulic Unit',
      type: 'Turning'
    };
    const genericLoad = {
      siteID: this.siteId,
      subType: 'Generic Load',
      type: 'Turning'
    };
    const areaSpecificSensorLoad = {
      siteID: this.siteId,
      type: 'GenericSensorLoad'
    };
    const siteLevelSensors = {
      siteID: this.siteId,
      type: 'SiteLevel_Sensors'
    };
    if (this.loadsBuilt === false) {
      // eslint-disable-next-line max-len
      // this.loads = [{'loadId': '123PC1108', 'loadName': 'Kadia Honing & Pin Pressing', 'rId': '#857:370', 'extraInfo': {}, 'parameters': [{'name': 'partCounter', 'unit': 'Unit', 'other': false}, {'name': 'electricalParams', 'unit': '', 'other': false}], 'kwRating': 35, 'kwThreshold': null, 'kvaRating': null, 'attachments': null, 'type': null, 'subType': null, 'make': '12344', 'idealPowerConsumption': null, 'comment': null, 'thermoclines': 0, 'inlets': null, 'outlets': null, 'meter': null, 'machineID': null, 'hasEnergyMeter': null, 'siteID': null, 'paramArr': ['Shiftwaise Energy', 'On Duration', 'Energy', 'Real Time Power', 'Voltage', 'Current', 'Power Factor', 'No data received'], '$$hashKey': 'object:5457'}, {'loadId': 'makThermal1591', 'loadName': 'SDB-4', 'rId': '#71:3', 'extraInfo': {}, 'parameters': [{'name': 'electricalParams', 'unit': '', 'other': false}], 'kwRating': 50, 'kwThreshold': null, 'kvaRating': null, 'attachments': null, 'type': null, 'subType': null, 'make': 'make', 'idealPowerConsumption': null, 'comment': null, 'thermoclines': 0, 'inlets': null, 'outlets': null, 'meter': null, 'machineID': null, 'hasEnergyMeter': null, 'siteID': null, 'paramArr': ['Test', 'Test 1', 'Real Time Power', 'Voltage', 'Current', 'Power Factor', 'No data received'], '$$hashKey': 'object:5458'}];
      this.siteService
        .getNonHydraulicLoadsBySiteId(this.siteId)
        .subscribe((nonHydData) => {
          for (let i = 0; i < nonHydData.length; i++) {
            const load = nonHydData[i];
            nonHydData[i].paramArr = this.buildLoadParams(load, true);
          }
          this.loads = nonHydData;
          forkJoin(
            this.siteService.getLoadsBasedOnTypeAndSubType(hydLoad),
            this.siteService.getLoadsBasedOnTypeAndSubType(genericLoad),
            this.siteService.getLoadsBasedOnTypeAndSubType(
              areaSpecificSensorLoad
            ),
            this.siteService.getLoadsBasedOnTypeAndSubType(siteLevelSensors)
          ).subscribe(
            ([
              hydData,
              genericLoadData,
              areaSpecificSensorLoadData,
              siteLevelSensorsData
            ]) => {
              // Get all hydraulic loads of the site
              for (let i = 0; i < hydData.length; i++) {
                if (hydData[i].hasEnergyMeter === 'YES') {
                  hydData[i].paramArr = this.buildLoadParams(hydData[i], true);
                } else {
                  hydData[i].paramArr = [];
                }
                hydData[i].digitalIOMap = {};
                this.AddParamForHydLoads(hydData[i]);
                this.loads.push(hydData[i]);
              }
              // Get all Generic loads of the site
              for (let i = 0; i < genericLoadData.length; i++) {
                if (genericLoadData[i].hasEnergyMeter === 'YES') {
                  genericLoadData[i].paramArr = this.buildLoadParams(
                    genericLoad[i],
                    true
                  );
                } else {
                  genericLoadData[i].paramArr = [];
                }
                genericLoadData[i].digitalIOMap = {};
                this.AddParamForHydLoads(genericLoadData[i]);
                this.loads.push(genericLoadData[i]);
              }
              // Get all Area Specific Sensor loads of the site
              for (let i = 0; i < areaSpecificSensorLoadData.length; i++) {
                if (areaSpecificSensorLoadData[i].hasEnergyMeter === 'YES') {
                  areaSpecificSensorLoadData[i].paramArr = this.buildLoadParams(
                    areaSpecificSensorLoadData[i],
                    true
                  );
                } else {
                  areaSpecificSensorLoadData[i].paramArr = [];
                }
                areaSpecificSensorLoadData[i].digitalIOMap = {};
                this.AddParamForHydLoads(areaSpecificSensorLoadData[i]);
                this.loads.push(areaSpecificSensorLoadData[i]);
              }
              // Get Site Level Sensors
              for (let i = 0; i < siteLevelSensorsData.length; i++) {
                if (siteLevelSensorsData[i].hasEnergyMeter === 'YES') {
                  // Check later
                  // siteLevelSensorsData[i].paramArr = this.commonService.buildLoadParams(areaSpecificSensorLoad[i], true);
                  siteLevelSensorsData[i].paramArr = this.buildLoadParams(
                    siteLevelSensorsData[i],
                    true
                  );
                } else {
                  siteLevelSensorsData[i].paramArr = [];
                }
                siteLevelSensorsData[i].digitalIOMap = {};
                this.AddParamForHydLoads(siteLevelSensorsData[i]);
                this.loads.push(siteLevelSensorsData[i]);
              }
              this.initFilterLoad();
            }
          );
        });
      // Need Combine all into one
      this.initFilterLoad();
      this.loadsBuilt = true;
    }
  };
  private buildLoadParams = (load: any, forAlertConfig: boolean) => {
    let loadParamArr = [];
    let allElectricalParams = [];
    let otherParams = [];
    const flowParams = [
      { text: 'Flow Rate', value: 'flowrate' },
      { text: 'Total Flow', value: 'totalflow' }
    ];
    const paramTemperature = { text: 'Temperature', value: 'ambient_temp' };
    const paramPressure = { text: 'Pressure', value: 'ambient_pressure' };
    const paramCFMOutput = { text: 'CFM Output', value: 'CFM' };
    const fuelParam = { text: 'Fuel Consumption', value: 'fuelConsumption' };
    const irdSensorOutput = {
      text: 'Irradiation Sensor Output',
      value: 'IrradiationSensorOutput'
    };
    if (forAlertConfig === true) {
      allElectricalParams = [
        'On Duration',
        'Energy',
        'Real Time Power',
        'Voltage',
        'Current',
        'Power Factor' /* 'Shiftwaise Energy' */
      ];
    } else {
      allElectricalParams = [
        { text: 'current', value: 'current' },
        { text: 'currentA', value: 'currentA' },
        { text: 'currentB', value: 'currentB' },
        { text: 'currentC', value: 'currentC' },
        { text: 'voltage', value: 'voltage' },
        { text: 'voltageA', value: 'voltageA' },
        { text: 'voltageB', value: 'voltageB' },
        { text: 'voltageC', value: 'voltageC' },
        { text: 'powerfactor', value: 'powerfactor' },
        { text: 'powerfactorA', value: 'powerfactorA' },
        { text: 'powerfactorB', value: 'powerfactorB' },
        { text: 'powerfactorC', value: 'powerfactorC' },
        { text: 'realtimepower', value: 'realtimepower' },
        { text: 'realtimeenergy', value: 'realtimeenergy' },
        { text: 'registerenergy', value: 'registerenergy' },
        { text: 'Shiftwaise Energy', value: 'shiftwaiseenergy' }
      ];
    }
    otherParams = [
      paramTemperature,
      paramPressure,
      paramCFMOutput,
      fuelParam,
      irdSensorOutput
    ];
    if (load.parameters != null) {
      for (let j = 0; j < load.parameters.length; j++) {
        const param = load.parameters[j];
        switch (param.name) {
          case Constants.LOAD_PARAM.ALL_ELECTRICAL:
            const temp = allElectricalParams.map((x: any) => ({
              text: x,
              value: x
            }));
            // loadParamArr = loadParamArr.concat(allElectricalParams);
            loadParamArr = loadParamArr.concat(temp);
            break;
          case Constants.LOAD_PARAM.TEMPERATURE:
            loadParamArr.push(paramTemperature);
            loadParamArr = loadParamArr.concat(irdSensorOutput);
            break;
          case Constants.LOAD_PARAM.PRESSURE:
            loadParamArr.push(paramPressure);
            break;
          case Constants.LOAD_PARAM.FLOW_OUTPUT:
            loadParamArr.push(paramCFMOutput);
            loadParamArr.push(fuelParam);
            break;
          case Constants.LOAD_PARAM.ALL_WATER:
            loadParamArr = loadParamArr.concat(flowParams);
            break;
          default:
            loadParamArr.push({ text: param.name, value: param.name });
        }
      }
    }
    if (loadParamArr.length === 0) {
      loadParamArr = allElectricalParams.concat(otherParams);
    }
    return loadParamArr;
  };
  private AddParamForHydLoads = (hydLoad: any) => {
    if (
      hydLoad.loadId !== null &&
      hydLoad.loadId !== undefined &&
      hydLoad.loadId !== ''
    ) {
      this.siteService
        .getLoadDetail(this.siteId, hydLoad.loadId)
        .subscribe((data) => {
          const flowChannels = [];
          if (data.inlets != null && data.inlets.length > 0) {
            for (let i = 0; i < data.inlets.length; i++) {
              flowChannels.push(data.inlets[i]);
            }
          }
          if (data.outlets != null && data.outlets.length > 0) {
            for (let i = 0; i < data.outlets.length; i++) {
              flowChannels.push(data.outlets[i]);
            }
          }

          // Build Hydraulic parameter
          for (let i = 0; i < flowChannels.length; i++) {
            hydLoad.paramArr.push(flowChannels[i].name);
            // if sensor has digital class, build a map with data.extraInfo.LoadNodeData[i].info[j].name and it's corresponding digital output
            if (
              flowChannels[i].sensor != null &&
              flowChannels[i].sensor.digitalOutputMapping != null
            ) {
              // eslint-disable-next-line max-len
              hydLoad.digitalIOMap[flowChannels[i].name] = [
                flowChannels[i].sensor.digitalOutputMapping.di_0,
                flowChannels[i].sensor.digitalOutputMapping.di_1
              ];
            }
          }
          //this.loads.push(hydLoad);
        });
    } else {
      if (hydLoad.type == 'SiteLevel_Sensors') {
        // Type and SiteID
        const siteLevelSensorParams = {
          siteID: hydLoad.siteID
        };
        this.siteService
          .getSiteLevelSensorDetails(siteLevelSensorParams)
          .subscribe((data) => {
            const flowChannels = [];
            if (data.inlets != null && data.inlets.length > 0) {
              for (let i = 0; i < data.inlets.length; i++) {
                flowChannels.push(data.inlets[i]);
              }
            }
            // Build Hydraulic parameter
            for (let i = 0; i < flowChannels.length; i++) {
              hydLoad.paramArr.push(flowChannels[i].name);
              // eslint-disable-next-line max-len
              // if sensor has digital class, build a map with data.extraInfo.LoadNodeData[i].info[j].name and it's corresponding digital output
              if (
                flowChannels[i].sensor != null &&
                flowChannels[i].sensor.digitalOutputMapping != null
              ) {
                // eslint-disable-next-line max-len
                hydLoad.digitalIOMap[flowChannels[i].name] = [
                  flowChannels[i].sensor.digitalOutputMapping.di_0,
                  flowChannels[i].sensor.digitalOutputMapping.di_1
                ];
              }
            }
            //this.loads.push(hydLoad);
          });
      }
    }
    return hydLoad;
  };
  public addNewAlert = (event: any) => {
    event.preventDefault();
    this.isAddingOrUpdatingAlert = true;
    this.selectedAlertRId = null;
    this.initAlertObject();
    this.addCondition();
  };
  public addCondition = () => {
    if (
      this.alert.alertConditions !== undefined &&
      this.alert.alertConditions.length < this.maxAlertConditions
    ) {
      const alertConditionsItems = this.formMasterGroup.get(
        'alertConditionsItems'
      ) as UntypedFormArray;
      const temp = new AlertConditionModel();
      temp.watchWindowOnDays = this.customDays;
      this.alert.alertConditions.push(temp);
      alertConditionsItems.push(this.createAlertConditionsItems());
      // this.setInitialLoad(this.alert.alertConditions.length - 1);
    }
  };
  public removeCondition = (event: any, index: number) => {
    event.preventDefault();
    if (
      this.alert.alertConditions !== undefined &&
      this.alert.alertConditions.length > 0
    ) {
      this.alert.alertConditions.splice(index, 1);
      const alertConditionsItems = this.formMasterGroup.get(
        'alertConditionsItems'
      ) as UntypedFormArray;
      alertConditionsItems.controls.splice(index, 1);
      alertConditionsItems.updateValueAndValidity();
    }
  };
  public editAlert = (event: any, asNew: boolean) => {
    event.preventDefault();
    this.isAddingOrUpdatingAlert = true;
    const currentAlertIndex = this.origAlerts.findIndex(
      (x) => x.alertId === this.selectedAlertRId
    );
    if (currentAlertIndex !== null) {
      const currentAlert = cloneDeep(this.origAlerts[currentAlertIndex]);
      this.alert = cloneDeep(currentAlert);
      this.clearChildAlert();
      const currentAlertConditions = currentAlert.alertConditions;
      // Add Condition Control based on currentAlertConditions
      for (let i = 0; i < currentAlertConditions.length; i++) {
        this.addCondition();
      }
      // Update Condition Control
      for (let i = 0; i < currentAlertConditions.length; i++) {
        const control = (<UntypedFormArray>(
          this.formMasterGroup.get('alertConditionsItems')
        )).controls[i];
        const watchWindowOnDay = currentAlertConditions[i].watchWindowOnDays;
        const currentAlertCondition = currentAlertConditions[i];
        const load = this.loads.find(
          (x) => x.rId === currentAlertCondition.load.rId
        );
        if (load !== null) {
          this.alert.alertConditions[i].load = currentAlertCondition.load;
          this.alert.alertConditions[i].load.paramArr = load.paramArr;
          this.alert.alertConditions[i].load.digitalIOMap = load.digitalIOMap;
          // Check later
          // $scope.showDigitalValueMap[k] = false;
          // $scope.keepConditionSelection[k] = true;
        }
        this.alert.alertConditions[i].logicOperator =
          currentAlertCondition.logicOperator;
        this.alert.alertConditions[i].parameter =
          currentAlertCondition.parameter;
        this.alert.alertConditions[i].conditionOperator =
          currentAlertCondition.conditionOperator;
        this.alert.alertConditions[i].conditionValue = parseFloat(
          currentAlertCondition.conditionValue
        );

        // const parameterCtr = control.get('parameterCtr');
        // parameterCtr.setValue(currentAlertCondition.parameter);
        // parameterCtr.updateValueAndValidity();
        // const conditionOperatorCtr = control.get('conditionOperatorCtr');
        // conditionOperatorCtr.setValue(currentAlertCondition.conditionOperator);
        // conditionOperatorCtr.updateValueAndValidity();
        const temp = this.alert.alertConditions[i].watchWindowOnDays;
        for (let k = 0; k < temp.length; k++) {
          temp[k].selected = false;
          if (
            watchWindowOnDay.findIndex((x: any) => x === temp[k].value) > -1
          ) {
            temp[k].selected = true;
            const daysCtr = (<UntypedFormArray>(
              control.get('watchWindowOnDaysArray')
            )).controls[k];
            const tempDay = daysCtr.get('dayOnWatchWindowCtr_' + k);
            tempDay.patchValue(true);
            tempDay.updateValueAndValidity();
          }
        }
        // this.alert.alertConditions[i] = currentAlertCondition as AlertConditionModel;
        this.alert.alertConditions[i].watchWindowOnDays = temp;

        // Object.assign(this.alert.alertConditions[i], currentAlertCondition);
        this.alert.alertConditions[i].watchWindowFromTime = moment(
          currentAlertCondition.watchWindowFromTime
        )
          .utc()
          .format(Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT);
        this.alert.alertConditions[i].watchWindowToTime = moment(
          currentAlertCondition.watchWindowToTime
        )
          .utc()
          .format(Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT);
      }
      if (asNew) {
        this.alert.rId = undefined;
      }
      const currentAlertNotificationDetails =
        currentAlert.alertNotificationDetails;
      // alertNotificationDetails
      this.form.alertContentType = 'custom';
      for (let i = 0; i < this.alert.alertNotificationDetails.length; i++) {
        this.setChkBoxAlertTypeValidator(i);
        const temp = this.alert.alertNotificationDetails[i];
        const flag: any = Array.from(currentAlertNotificationDetails).find(
          (x: any) => x.type === temp.type.value
        );
        if (flag) {
          temp.type.selected = true;
          temp.frequency = flag.frequency;
          this.alertContent = flag.content;
        }
      }
      this.alertTypeAll = this.alert.alertNotificationDetails.every(function (
        item: any
      ) {
        return item.type.selected === true;
      });
      for (let j = 0; j < this.alert.alertConditions.length; j++) {
        for (let i = 0; i < this.shifts.length; i++) {
          if (
            this.alert.alertConditions[j].shiftwise !== undefined &&
            this.alert.alertConditions[j].shiftwise !== null &&
            this.alert.alertConditions[j].shiftwise.shiftId ===
              this.shifts[i].shiftId
          ) {
            this.alert.alertConditions[j].shiftwise = this.shifts[i];
            break;
          }
        }
      }
      // alertLevels
      const currentAlertLevels = currentAlert.alertLevels;
      for (let i = 0; i < this.alert.alertLevels.length; i++) {
        const temp = this.alert.alertLevels[i];
        const flag: any = Array.from(currentAlertLevels).find(
          (x: any) => x === temp.value
        );
        if (flag) {
          temp.selected = true;
        }
      }
      const currentSendWindowOnDays = currentAlert.sendWindowOnDays;
      for (let i = 0; i < this.alert.sendWindowOnDays.length; i++) {
        this.alert.sendWindowOnDays[i].selected = false;
        const temp = this.alert.sendWindowOnDays[i];
        const flag: any = Array.from(currentSendWindowOnDays).find(
          (x: any) => x === temp.value
        );
        if (flag) {
          temp.selected = true;
        }
      }
      this.alert.sendWindowFromTime = moment(currentAlert.sendWindowFromTime)
        .utc()
        .format(Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT);
      this.alert.sendWindowToTime = moment(currentAlert.sendWindowToTime)
        .utc()
        .format(Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT);
      //
      this.alert.activate = currentAlert.activate.toString();
    }
  };
  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formMasterGroup.get(fieldName).hasError(errorCode);
  };
  public isFieldHasErrorInFormMisGroup = (
    fieldName: string,
    errorCode: string
  ): boolean => {
    return this.formMisGroup.get(fieldName).hasError(errorCode);
  };
  public isFieldHasErrorinConditionsItems = (
    fieldName: string,
    index: number,
    errorCode: string
  ): boolean => {
    let control: AbstractControl;
    control = (<UntypedFormArray>(
      this.formMasterGroup.get('alertConditionsItems')
    )).controls[index];
    if (control !== null && control !== undefined) {
      const temp = control.get(fieldName);
      if (temp !== null && temp !== undefined) {
        return temp.hasError(errorCode);
      }
    }
    return false;
  };
  public changeLoad = (event: any, index: number) => {
    this.alert.alertConditions[index].parameter = '';
    this.showDigitalValueMap[index] = false;
    this.keepConditionSelection[index] = true;
    this.alert.alertConditions[index].conditionOperator = '';
    this.alert.alertConditions[index].conditionValue = undefined;
    this.setAlertContent();
    const control = (<UntypedFormArray>(
      this.formMasterGroup.get('alertConditionsItems')
    )).controls[index];
    const parameterCtr = control.get('parameterCtr');
    parameterCtr.setValue(null);
    parameterCtr.updateValueAndValidity();
  };
  public changeLoadFilter = (event: any, index: number) => {
    const control = (<UntypedFormArray>(
      this.formMasterGroup.get('alertConditionsItems')
    )).controls[index];
    const temp = control.get('loadSearchCtr');
    temp.valueChanges.pipe(takeUntil(this._onLoadDestroy)).subscribe(() => {
      this.filterLoads(temp);
    });
  };
  public checkIfDigitalParam = (event: any, index: number) => {
    const control = (<UntypedFormArray>(
      this.formMasterGroup.get('alertConditionsItems')
    )).controls[index];
    const shiftwiseCtr = control.get('shiftwiseCtr');
    const parameterCtr = control.get('parameterCtr');
    const conditionOperatorCtr = control.get('conditionOperatorCtr');
    const conditionValueCtr = control.get('conditionValueCtr');
    if (
      parameterCtr !== null &&
      parameterCtr.value !== null &&
      parameterCtr.value === 'Shiftwaise Energy'
    ) {
      shiftwiseCtr.setValidators(this.requiredValidators);
    } else {
      shiftwiseCtr.setValue(null);
      shiftwiseCtr.setValidators(null);
    }
    shiftwiseCtr.updateValueAndValidity();
    if (
      parameterCtr !== null &&
      parameterCtr.value !== null &&
      parameterCtr.value === 'No data received'
    ) {
      conditionOperatorCtr.setValue(null);
      conditionOperatorCtr.setValidators(null);
      conditionOperatorCtr.disable();
      conditionValueCtr.setValue(null);
      conditionValueCtr.setValidators(null);
      conditionValueCtr.disable();
    } else {
      conditionOperatorCtr.enable();
      conditionOperatorCtr.setValidators(this.requiredValidators);
      conditionValueCtr.enable();
      conditionValueCtr.setValidators(this.valueValidators);
    }
    conditionOperatorCtr.updateValueAndValidity();
    conditionValueCtr.updateValueAndValidity();
    //
    if (
      this.alert.alertConditions !== undefined &&
      this.alert.alertConditions[index].load !== undefined &&
      this.alert.alertConditions[index].load.digitalIOMap !== undefined &&
      Object.keys(this.alert.alertConditions[index].load.digitalIOMap).length >
        0 &&
      this.alert.alertConditions[index].load.digitalIOMap[
        this.alert.alertConditions[index].parameter
      ] !== undefined
    ) {
      this.showDigitalValueMap[index] = true;
      this.keepConditionSelection[index] = false;
      this.alert.alertConditions[index].conditionOperator = '=';
      this.alert.alertConditions[index].conditionValue = '';
    } else {
      this.showDigitalValueMap[index] = false;
      this.keepConditionSelection[index] = true;
      this.alert.alertConditions[index].conditionOperator = '';
      this.alert.alertConditions[index].conditionValue = undefined;
    }
    this.setAlertContent();
  };
  public setAlertContent = () => {
    if (this.form.alertContentType === 'default') {
      this.alertContent = this.buildDefaultAlertContent();
    }
  };
  private getText = (text: any, undefinedText: any) => {
    return text === undefined ? undefinedText : text;
  };
  private buildDefaultAlertContent = () => {
    let alertConditions = '';
    for (let i = 0; i < this.alert.alertConditions.length; i++) {
      alertConditions +=
        ' ' +
        (this.alert.alertConditions[i].logicOperator === undefined
          ? ''
          : this.alert.alertConditions[i].logicOperator) +
        ' ' +
        (this.alert.alertConditions[i].load !== undefined
          ? this.getText(this.alert.alertConditions[i].load.name, '[LOAD NAME]')
          : '') +
        ', ' +
        this.getText(this.alert.alertConditions[i].parameter, '[PARAMETER]') +
        // eslint-disable-next-line max-len
        (this.alert.alertConditions[i].shiftwise !== undefined
          ? ' ' +
            this.getText(
              this.alert.alertConditions[i].shiftwise.shiftName,
              '[SHIFT]'
            )
          : '') +
        ', ' +
        // Update later
        // + this.getText($filter('textFromValue')(
        //     this.alert.alertConditions[i].conditionOperator, this.operators),
        //     '[OPERATOR]')
        //     + ' '
        // eslint-disable-next-line max-len
        (this.alert.alertConditions[i].parameter !== 'No data received'
          ? this.getText(
              this.alert.alertConditions[i].conditionValue,
              '[CONDITION VALUE]'
            )
          : '');
    }
    const defaultContent =
      this.getText(this.alert.criticalityLevel, '[CRITICALITY LEVEL]') +
      ' ALERT!!! ' +
      alertConditions;
    return defaultContent;
  };
  private initFilterLoad = () => {
    if (this.loads && this.loads.length > 0) {
      this.filteredLoads.next(this.loads.slice());
    }
  };
  private filterLoads = (control: AbstractControl) => {
    if (!this.loads) {
      return;
    }
    // get the search keyword
    let search = control.value;
    if (!search) {
      this.filteredLoads.next(this.loads.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredLoads.next(
      this.loads.filter((load) => load.name.toLowerCase().indexOf(search) > -1)
    );
  };
  private setInitialLoad = (index: number) => {
    this.filteredLoads
      .pipe(take(1), takeUntil(this._onLoadDestroy))
      .subscribe(() => {
        // Get load contrl by index
        // const control = (<FormArray>this.formMasterGroup.get('alertConditionsItems')).controls[index];
        // const temp = control.get('loadCtr');
        // this.loadSelectIds.find(x=> x === index)[0];
        const matSelect = this.loadSelect.find(
          (x) => x.id === index.toString()
        );
        matSelect.compareWith = (a: any, b: any) => a && b && a.rId === b.rId;
      });
  };
  public compareFnLoad = (a: any, b: any) => {
    return a && b && a.rId === b.rId;
  };
  public changeChkBoxDays = (event: any, index: number, dayIndex: number) => {
    // const control = (<FormArray>this.formMasterGroup.get('alertConditionsItems')).controls[index];
    // const watchWindowOnDaysArray = (<FormArray>this.formMasterGroup.get('watchWindowOnDaysArray')).controls[dayIndex];
    const temp = cloneDeep(this.alert.alertConditions[index].watchWindowOnDays);
    temp[dayIndex].selected = event.checked;
    this.alert.alertConditions[index].watchWindowOnDays = temp;
    // this.alert.alertConditions[index].watchWindowOnDays[dayIndex].selected = event.checked;
  };
  public changeChkBoxSendWindowOnDay = (event: any, index: number) => {
    this.alert.sendWindowOnDays[index].selected = event.checked;
  };
  public checkAllAlertType = () => {
    for (let i = 0; i < this.alert.alertNotificationDetails.length; i++) {
      this.alert.alertNotificationDetails[i].type.selected = this.alertTypeAll;
      this.setChkBoxAlertTypeValidator(i);
    }
  };
  public changeChkBoxAlertType = (index: number) => {
    this.setChkBoxAlertTypeValidator(index);
    this.alertTypeAll = this.alert.alertNotificationDetails.every(function (
      item: any
    ) {
      return item.type.selected === true;
    });
  };
  private setChkBoxAlertTypeValidator = (index: number) => {
    const alertNotificationFrequencyCtr = this.formMasterGroup.get(
      'alertNotificationFrequencyCtr_' + index
    );
    if (this.alert.alertNotificationDetails[index].type.selected) {
      alertNotificationFrequencyCtr.enable();
      alertNotificationFrequencyCtr.setValidators(this.requiredValidators);
    } else {
      alertNotificationFrequencyCtr.disable();
      alertNotificationFrequencyCtr.setValue(null);
      alertNotificationFrequencyCtr.setValidators(null);
    }
    alertNotificationFrequencyCtr.updateValueAndValidity();
  };
  public onAlertContentTypeChange = () => {
    this.setAlertContent();
    const alertContentCtr = this.formMasterGroup.get('alertContentCtr');
    this.form.alertContentType !== 'custom'
      ? alertContentCtr.disable()
      : alertContentCtr.enable();
    alertContentCtr.updateValueAndValidity();
  };
  public checkAllAlertLevel = () => {
    for (let i = 0; i < this.alert.alertLevels.length; i++) {
      this.alert.alertLevels[i].selected = this.alertLevelAll;
    }
  };
  public checkForAllAlertLevel = () => {
    this.alertLevelAll = this.alert.alertLevels.every(function (item: any) {
      return item.selected === true;
    });
  };
  public onAlertToMISReportChange = () => {
    // const newServiceCtr = this.formMisGroup.get('newServiceCtr');
    const enabledAlertCtr = this.formMisGroup.get('enabledAlertCtr');
    const misServiceCtr = this.formMisGroup.get('misServiceCtr');
    const criticalityMisLevelCtr = this.formMisGroup.get(
      'criticalityMisLevelCtr'
    );
    if (this.AlertToMISReport === 'yes') {
      // newServiceCtr.setValidators(this.requiredValidators);
      enabledAlertCtr.setValidators(this.requiredValidators);
      misServiceCtr.setValidators(this.requiredValidators);
      criticalityMisLevelCtr.setValidators(this.requiredValidators);
    } else {
      //  newServiceCtr.setValidators(null);
      enabledAlertCtr.setValidators(null);
      misServiceCtr.setValidators(null);
      criticalityMisLevelCtr.setValidators(null);
    }
    // newServiceCtr.updateValueAndValidity();
    enabledAlertCtr.updateValueAndValidity();
    misServiceCtr.updateValueAndValidity();
    criticalityMisLevelCtr.updateValueAndValidity();
  };
  public onDisplayOnPortalChange = () => {
    const targetDurationCtr = this.formMisGroup.get('targetDurationCtr');
    if (this.alert.displayOnPortal === 'true') {
      targetDurationCtr.setValidators(this.requiredValidators);
    } else {
      targetDurationCtr.setValidators(null);
    }
    targetDurationCtr.updateValueAndValidity();
  };
  public onColumnsOnPortalChange = (event: any, index: number) => {
    // For Radio
    // this.resetChkBoxColumnsOnPortal();
    const temp = cloneDeep(this.alert.columnsOnPortal);
    // For Radio
    // temp[index].selected = event.target.checked;
    temp[index].selected = event.checked;
    this.alert.columnsOnPortal = temp;
    this.setChkBoxColumnsOnPortalValidator(index);
  };
  private resetChkBoxColumnsOnPortal = () => {
    this.alert.columnsOnPortal.forEach(
      (item: { selected: boolean }, index: number) => {
        item.selected = false;
        this.setChkBoxColumnsOnPortalValidator(index);
      }
    );
  };
  private setChkBoxColumnsOnPortalValidator = (index: number) => {
    const columnsOnPortalCtr = this.formMisGroup.get(
      'columnsOnPortalCtr_' + index
    );
    if (this.alert.columnsOnPortal[index].selected) {
      columnsOnPortalCtr.enable();
      // columnsOnPortalCtr.setValidators(this.requiredValidators);
    } else {
      columnsOnPortalCtr.disable();
      columnsOnPortalCtr.setValue(null);
      // columnsOnPortalCtr.setValidators(null);
    }
    columnsOnPortalCtr.updateValueAndValidity();
  };
  public uploadDocument = (event: any, pictType: string, index: number = 0) => {
    if (event.target.files.length <= 0) {
      return;
    }
    const files = event.target.files;
    if (!this.commonService.isImageFile(files[0])) {
      this.commonService.showDialogMessage('File type not supported!');
      return;
    }
    const formData = new FormData();
    formData.append('file', files[0]);
    formData.append('documentType', pictType);
    this.siteService
      .uploadDocument(formData, pictType, 'comment', this.siteId)
      .subscribe((data) => {
        if (data === '') {
          this.alertService.message = 'Upload file fail!';
          return;
        }
        if (data.documentType === Constants.DOCUMENT_TYPE.MIS_SERVICE_LOGO) {
          this.logoAttachment = data;
        }
      });
  };
  public selectDocument = (elmId: string) => {
    const element: HTMLElement = document.getElementById(elmId);
    element!.click();
  };
  public saveMISDetails = () => {
    // const alertForSave = this.getAlertObject(true);
    const alertForSave = cloneDeep(this.alert);
    let param = {
      enabledAlert: alertForSave.enabledAlert,
      misService: alertForSave.misService,
      criticalityMisLevel: alertForSave.criticalityMisLevel,
      cost: alertForSave.cost,
      currency: alertForSave.currency
    };
    alertForSave.attachments = [];
    alertForSave.attachments.push(this.logoAttachment);
    this.siteService.saveMIS(this.siteId, param).subscribe((data) => {
      this.alertService.message = 'Save MIS is successfully!';
      this.alertService.showSuccess(this.alertService.message);
      this.fetchSavedAlerts();
      this.getExistingMISserviceList();
    });
  };
  public createNewService = (event: any) => {
    event.preventDefault();
    const params = {
      SiteID: this.siteId,
      MisServiceName: this.alert.newService
    };
    this.siteService.createNewService(params).subscribe((data) => {
      if (data.data === 'Success') {
        this.alertService.message = 'Save MIS is successfully!';
        this.alertService.showSuccess(this.alertService.message);
        this.alert.newService = null;
        this.getExistingMISserviceList();
      } else if (data.data === 'Fail') {
        this.alertService.message = 'Failed to create MIS Service..!!';
        this.alertService.showError(this.alertService.message);
      } else {
        this.alertService.message = 'MIS Service already present..!!';
        this.alertService.showError(this.alertService.message);
      }
    });
  };
  private createAlertConditionsItems = (): UntypedFormGroup => {
    return this.fb.group({
      logicOperatorCtr: [''],
      // logicOperatorCtr: ['', [Validators.required]],
      loadCtr: ['', [Validators.required]],
      loadSearchCtr: [''],
      parameterCtr: ['', [Validators.required]],
      parameterSearchCtr: [''],
      shiftwiseCtr: [''],
      conditionOperatorCtr: [''],
      conditionValueCtr: [''],
      watchWindowFromTimeCtr: [
        '',
        [Validators.required, this.timeCompare('watchWindowToTimeCtr')]
      ],
      watchWindowToTimeCtr: [
        '',
        [Validators.required, this.timeCompare('watchWindowFromTimeCtr')]
      ],
      watchWindowOnDaysArray: this.fb.array(
        this.createWatchWindowOnDayRangeCtr()
      )
    });
  };
  private createWatchWindowOnDayRangeCtr = (): UntypedFormGroup[] => {
    const result = [];
    for (let i = 0; i < this.days.length; i++) {
      const form = this.fb.group({
        dayOnWatchWindowCtr_0: [''],
        dayOnWatchWindowCtr_1: [''],
        dayOnWatchWindowCtr_2: [''],
        dayOnWatchWindowCtr_3: [''],
        dayOnWatchWindowCtr_4: [''],
        dayOnWatchWindowCtr_5: [''],
        dayOnWatchWindowCtr_6: ['']
      });
      result.push(form);
    }
    return result;
  };
  public submit = () => {
    const alertForSave = this.getAlertObject(false);
    this.siteService.saveAlertForSite(alertForSave).subscribe((data) => {
      this.alertService.message =
        'Alert Configuration is updated successfully!';
      if (this.selectedAlertRId === null) {
        this.alertService.message =
          'Create Alert Configuration is successfully!';
        this.formDirective.resetForm();
        this.formMasterGroup.reset();
        this.initAlertObject();
      }
      this.alertService.showSuccess(this.alertService.message);
      this.fetchSavedAlerts();
      this.getExistingAlertList();
    });
  };
  public goPrevious = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.ReservesAndSources, this.siteModel)
    );
  };
  public goTo = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.WidgetConfiguration, this.siteModel)
    );
  };
  private getAlertObject = (isFromMisReport: boolean) => {
    const alertForSave = cloneDeep(this.alert);
    alertForSave.siteId = this.siteId;
    const year = new Date().getFullYear();
    const month = new Date().getMonth();
    const date = new Date().getDate();
    let splitHourStartTime: any;
    let splitHourEndTime: any;
    // alertNotificationDetails
    alertForSave.alertNotificationDetails = Array.from(
      alertForSave.alertNotificationDetails
    )
      .filter((x: { type: { selected: boolean } }) => x.type.selected === true)
      .map((x: any) => ({
        type: x.type.value,
        frequency: x.frequency,
        content: this.alertContent
      }));
    // alertConditions
    for (let i = 0; i < alertForSave.alertConditions.length; i++) {
      const alertCondition = alertForSave.alertConditions[i];
      alertCondition.index = i;
      if (alertForSave.alertConditions[i].watchWindowOnDays !== undefined) {
        alertForSave.alertConditions[i].watchWindowOnDays =
          alertForSave.alertConditions[i].watchWindowOnDays
            .filter((x: { selected: boolean }) => x.selected === true)
            .map((y: { value: any }) => y.value);
      }
      delete alertForSave.alertConditions[i].load.paramArr;
      delete alertForSave.alertConditions[i].digitalIOMap;
      if (
        !this.commonService.isNullOrUndefined(
          alertCondition.watchWindowFromTime
        )
      ) {
        splitHourStartTime = alertCondition.watchWindowFromTime.split(':');
      }
      if (
        !this.commonService.isNullOrUndefined(alertCondition.watchWindowToTime)
      ) {
        splitHourEndTime = alertCondition.watchWindowToTime.split(':');
      }
      if (
        splitHourStartTime instanceof Array &&
        splitHourStartTime.length > 0
      ) {
        alertCondition.watchWindowFromTime = Moment$(
          new Date(
            year,
            month,
            date,
            splitHourStartTime[0],
            splitHourStartTime[1],
            0
          )
        ).format(Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_ZONE);
      }
      if (splitHourEndTime instanceof Array && splitHourEndTime.length > 0) {
        alertCondition.watchWindowToTime = Moment$(
          new Date(
            year,
            month,
            date,
            splitHourEndTime[0],
            splitHourEndTime[1],
            0
          )
        ).format(Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_ZONE);
      }
    }
    // alertLevels
    alertForSave.alertLevels = alertForSave.alertLevels
      .filter((x: { selected: boolean }) => x.selected === true)
      .map((y: { value: any }) => y.value);
    // sendWindowFromTime vs sendWindowToTime
    if (
      !this.commonService.isNullOrUndefined(alertForSave.sendWindowFromTime)
    ) {
      splitHourStartTime = alertForSave.sendWindowFromTime.split(':');
    }
    if (!this.commonService.isNullOrUndefined(alertForSave.sendWindowToTime)) {
      splitHourEndTime = alertForSave.sendWindowToTime.split(':');
    }
    if (splitHourStartTime instanceof Array && splitHourStartTime.length > 0) {
      alertForSave.sendWindowFromTime = Moment$(
        new Date(
          year,
          month,
          date,
          splitHourStartTime[0],
          splitHourStartTime[1],
          0
        )
      ).format(Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_ZONE);
    }
    if (splitHourEndTime instanceof Array && splitHourEndTime.length > 0) {
      alertForSave.sendWindowToTime = Moment$(
        new Date(year, month, date, splitHourEndTime[0], splitHourEndTime[1], 0)
      ).format(Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_ZONE);
    }
    // sendWindowOnDays
    alertForSave.sendWindowOnDays = alertForSave.sendWindowOnDays
      .filter((x: { selected: boolean }) => x.selected === true)
      .map((y: { value: any }) => y.value);
    if (isFromMisReport === false) {
      // columnsOnPortal based on MIS report
      delete alertForSave.columnsOnPortal;
    } else {
      // alertForSave.columnsOnPortal = alertForSave.columnsOnPortal
      // .filter((x: { selected: boolean; }) => x.selected === true)
      // .map((y: { value: any; }) => y.value);
      alertForSave.columnsOnPortal = Array.from(alertForSave.columnsOnPortal)
        .filter((x: { selected: boolean }) => x.selected === true)
        .map((x: any) => ({ type: x.value, content: x.textValue }));
    }
    return alertForSave;
  };
  public invalidControl = (event: any) => {
    event.preventDefault();
    const invalid = [];
    const controls = this.formMisGroup.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    console.log('Invalid Conteol ---' + invalid);
  };
  checkExistedAlert() {
    const find = this.origAlerts.find((c) => c.name === this.alert.name);
    if (this.commonService.isNullOrUndefined(find)) {
      // this.formMasterGroup.get('alertNameCtr').setErrors({ 'duplicated': false });
      const error = this.formMasterGroup
        .get('alertNameCtr')
        .getError('duplicated');
      if (error) {
        this.formMasterGroup.get('alertNameCtr').setErrors(null);
      }
      this.isDuplicatedAlert = false;
    } else {
      this.formMasterGroup.get('alertNameCtr').setErrors({ duplicated: true });
      this.isDuplicatedAlert = true;
    }
  }
}
